
var apiLifeCycleManagement = [];
var currentApiLifeCycleValue = "";

// function to get stage value on load
function getStageValueOnLoad() {
    var stageParameter = new URLSearchParams(window.location.search);
    apiLifeCycleManagement = ['pilot', 'beta', 'new'];
    currentApiLifeCycleValue = "new";
    if (stageParameter.has('stage') && stageParameter.get('stage').toLowerCase() === 'hidden') {
        currentApiLifeCycleValue = "hidden";
        apiLifeCycleManagement = ['hidden', 'pilot', 'beta', 'new'];
    }
    return currentApiLifeCycleValue;
}

function isFirstLevelApiShown(firstLevelIdentifer, apiLifeCycle,menuGroupsResponse, isWidgetUseCase) {
    if(isWidgetUseCase){
        return true;
    }
    var firstLevelItem = getFirstLevelImageTagsInLifeCycle(firstLevelIdentifer, apiLifeCycle,menuGroupsResponse);
    if (firstLevelItem == null) {
        return true;
    } else {
        return (apiLifeCycleManagement.indexOf(firstLevelItem.toLowerCase()) > -1);
    }
}

function isSecondLevelApiShown(firstLevelIdentifer, secondLevelIdentifer, apiLifeCycle,menuGroupsResponse,isWidgetUseCase) {
    if(isWidgetUseCase){
        return true;
    }
    var secondLevelItem = getSecondLevelImageTagsInLifeCycle(firstLevelIdentifer, secondLevelIdentifer, apiLifeCycle,menuGroupsResponse );
    if (secondLevelItem == null) {
        return true;
    } else {
        return (apiLifeCycleManagement.indexOf(secondLevelItem.toLowerCase()) > -1);
    }
}

function isThirdLevelApiShown(currentApiLifeCycle, isWidgetUseCase) {
    if(isWidgetUseCase){
        return true;
    }
    // base case display all prod released apis
    if (currentApiLifeCycle == null || currentApiLifeCycle == undefined || currentApiLifeCycle.toLowerCase() == 'new' || currentApiLifeCycle == '') {
        return true;
    }

    // display all only apis that match this condition
    if (apiLifeCycleManagement != null) {
        if (currentApiLifeCycle != null && apiLifeCycleManagement.length > 0) {
            return (apiLifeCycleManagement.indexOf(currentApiLifeCycle.toLowerCase()) > -1);
        }
    }
}

function isThirdLevelImageTagsShown(currentApiLifeCycle) {
    if (currentApiLifeCycle == null || currentApiLifeCycle == undefined) {
        return false;
    }
    if (currentApiLifeCycle.toLowerCase() == 'new' || currentApiLifeCycle.toLowerCase() == 'hidden' || currentApiLifeCycle.toLowerCase() == 'pilot' || currentApiLifeCycle.toLowerCase() == 'beta') {
        return true;
    }
    return false;
}

function getFirstLevelImageTagsInLifeCycle(firstLevelIdentifer, apiLifeCycle, menuGroupsResponse) {
    if (apiLifeCycle == undefined || apiLifeCycle == "") {
        return null;
    }
    var temp_tagging = null;
    var firstLevelKeys = Object.keys((menuGroupsResponse));
    for (var i = 0; i < firstLevelKeys.length; i++) {
        if (firstLevelKeys[i] == firstLevelIdentifer) {
            var secondLevelKeys = Object.keys((menuGroupsResponse[firstLevelKeys[i]]));
            for (var j = 0; j < secondLevelKeys.length; j++) {
                if (secondLevelKeys[j] != "resellerSpecificName") {
                    for (var k = 0; k < menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"].length; k++) {
                        // if there exists one api with no api life cycle then api second level
                        if (menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["firstLevelApiLifeCycle"] == undefined) {
                            return null;
                        }
                        temp_tagging = menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["firstLevelApiLifeCycle"];
                    }
                    if (temp_tagging != null) {
                        if (apiLifeCycleManagement.indexOf(temp_tagging.toLowerCase()) > -1) {
                            // $scope.firstLevelImageTagging = temp_tagging;
                        }
                        return temp_tagging;
                    }
                    return null;
                }

                // key identifier is not matching with any of the existing cases or whole api family has different api lifecycle
            }
        }
    }
}

function getSecondLevelImageTagsInLifeCycle(firstLevelIdentifer, secondLevelIdentifer, apiLifeCycle, menuGroupsResponse) {
    if (apiLifeCycle == undefined || apiLifeCycle == "") {
        return null;
    }
    var temp_tagging = null;
    var firstLevelKeys = Object.keys((menuGroupsResponse));
    for (var i = 0; i < firstLevelKeys.length; i++) {
        if (firstLevelKeys[i] == firstLevelIdentifer) {
            var secondLevelKeys = Object.keys((menuGroupsResponse[firstLevelKeys[i]]));
            for (var j = 0; j < secondLevelKeys.length; j++) {
                if (secondLevelKeys[j] != "resellerSpecificName") {
                    if (secondLevelKeys[j] == secondLevelIdentifer) {
                        for (var k = 0; k < menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"].length; k++) {
                            // if there exists one api with no api life cycle then api second level
                            if (menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["secondLevelApiLifeCycle"] == undefined) {
                                return null;
                            }
                            temp_tagging = menuGroupsResponse[firstLevelKeys[i]][secondLevelKeys[j]]["child"][k]["secondLevelApiLifeCycle"];
                        }
                        if (temp_tagging != null) {
                            if (apiLifeCycleManagement.indexOf(temp_tagging.toLowerCase()) > -1) {
                                // $scope.secondLevelImageTagging = temp_tagging;
                            }
                            return temp_tagging;
                        }
                        return null;
                        // key identifier is not matching with any of the existing cases or whole api family has different api lifecycle
                    }
                }
            }
        }
    }
}

export default getStageValueOnLoad;
export {apiLifeCycleManagement,currentApiLifeCycleValue,isFirstLevelApiShown,isSecondLevelApiShown,isThirdLevelApiShown,isThirdLevelImageTagsShown,getFirstLevelImageTagsInLifeCycle,getSecondLevelImageTagsInLifeCycle};